<template>
    <VAppLayout>
        <VContainer>
            <VReviewAdd/>
        </VContainer>
    </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VReviewAdd from "@/modules/review/components/VReviewAdd.vue";
import VContainer from "@/components/ui/VContainer.vue";

export default {
    name: "ReviewTab",
    components: {
        VContainer,
        VReviewAdd,
        VAppLayout
    },
}
</script>

<style scoped>

.rate-us {
    padding: 32px 0;
}

</style>
